<template>
  <div id="main-content" class="cancel-list">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <el-row>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item>
            <el-date-picker
                v-model="date"
                type="date"
                :placeholder="$t('common.pick_a_day')"
                value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="exportData" :disabled="!date">{{ $t('common.export_excel') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="createCancel">{{ $t('common.add') }}</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <template v-if="data">
        <el-row style="padding-top: 20px">
          <table class="bus-list filter-sort-table">
            <tr>
              <th width="3%">#</th>
              <th width="11%" class="input-th">
                <el-input :placeholder="$t('common.full_name')" v-model="filter.name"></el-input>
                <Sort :model="sort.name" @change="changeSort($event, 'name')"></Sort>
              </th>
              <th width="11%" class="input-th">
                <el-input :placeholder="$t('common.romaji')" v-model="filter.romaji"></el-input>
                <Sort :model="sort.romaji" @change="changeSort($event, 'romaji')"></Sort>
              </th>
              <th width="11%" class="input-th">
                <el-input :placeholder="$t('common.furigana')" v-model="filter.furigana"></el-input>
                <Sort :model="sort.furigana" @change="changeSort($event, 'furigana')"></Sort>
              </th>
              <th width="8%" class="input-th">
                <select class="input filter-box" v-model="filter.class">
                  <option value="">{{ $t('common.class') }}</option>
                  <option v-for="classItem in sortedClassList" :key="classItem.id" :value="classItem.id">
                    {{ classItem.name }}
                  </option>
                </select>
                <Sort :model="sort.class" @change="changeSort($event, 'class')"></Sort>
              </th>
              <th width="11%" class="input-th">
                <el-input :placeholder="$t('common.bus_stop')" v-model="filter.place_name"></el-input>
                <Sort :model="sort.place_name" @change="changeSort($event, 'place_name')"></Sort>
              </th>
              <th width="8%" class="input-th no-sort">
                <select class="input filter-box" v-model="filter.type">
                  <option value="">{{ $t('common.type') }}</option>
                  <option :value="SCHEDULE_CANCEL_DATE">{{ $t('schedule.cancel_by_date') }}</option>
                  <option :value="SCHEDULE_CANCEL_DAY">{{ $t('schedule.cancel_by_day') }}</option>
                  <option :value="SCHEDULE_CANCEL_PERIOD">{{ $t('schedule.cancel_by_period') }}</option>
                  <option :value="SCHEDULE_BOOKING">{{ $t('schedule.booking') }}</option>
                </select>
              </th>
              <th width="11%" class="input-th">
                <Sort :model="sort.day" @change="changeSort($event, 'day')"></Sort>

                <select class="input filter-box" v-model="filter.day">
                  <option value="">{{ $t('common.day') }}</option>
                  <option v-for="day in getDayOptionList()" :value="day.value" :key="day.value">{{ day.label }}</option>
                </select>
              </th>
              <th width="9%" class="input-th">
                <el-input :placeholder="$t('schedule.reason')" v-model="filter.reason"></el-input>
                <Sort :model="sort.reason" @change="changeSort($event, 'reason')"></Sort>
              </th>
              <th width="10%" class="input-th">
                <el-date-picker
                    v-model="filter.created_at"
                    type="date"
                    :placeholder="$t('common.log_date')"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
                <Sort :model="sort.created_at" @change="changeSort($event, 'created_at')"></Sort>
              </th>
              <th>
                <el-button @click="resetFilter"
                   style="margin: 2px;" type="danger">{{ $t('common.reset') }}
                </el-button>
              </th>
            </tr>
            <tr v-for="(cancel, index) in data.data" :key="cancel.id">
              <td class="notification-no" :class="{ 'is-unread': !cancel.is_read }">
                {{ data.from + index }}
                <span class="notification-badge"></span>
              </td>
              <td>{{ cancel.fullname }}</td>
              <td>{{ cancel.romaji }}</td>
              <td>{{ cancel.furigana }}</td>
              <td>{{ cancel.class_name }}</td>
              <td>{{ cancel.place_name }}</td>
              <td>{{ getCancelType(cancel.type) }}</td>
              <td>{{ getData(cancel) }}</td>
              <td>{{ cancel.reason }}</td>
              <td>{{ $moment(cancel.created_at).format('YYYY-MM-DD H:mm:ss') }}</td>
              <td>
                <b-button variant="outline-primary" @click="goToDetail(cancel)">{{ $t('common.detail') }}
                </b-button>
                <b-button v-if="cancel.created_by" variant="danger" style="margin-top: 5px"
                          @click="deleteCancel(cancel)">{{ $t('common.delete') }}
                </b-button>
              </td>
            </tr>
          </table>
        </el-row>
        <el-row style="padding-top: 15px">
          <el-pagination
              v-show="data.total > data.per_page"
              background
              @current-change="didSelectPage"
              :page-size="data.per_page"
              layout="prev, pager, next"
              :current-page="data.current_page"
              :total="data.total">
          </el-pagination>
        </el-row>
      </template>
    </el-col>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import {
    SCHEDULE_CANCEL_DATE,
    SCHEDULE_CANCEL_DAY,
    SCHEDULE_CANCEL_PERIOD,
    SCHEDULE_BOOKING,
    USER_NOTIFICATION_TYPE_CANCEL,
    MONTH_LIST,
    DAY_LIST_FULL,
    WORKING_DAY_LIST
  } from '@/config'
  import PageTitle from '@/components/PageTitle'
  import Sort from '@/components/Sort'
  import { downloadFileFromBlob, classSort } from '@/utils'
  import moment from "moment";

  export default {
    name: 'CancelList',
    components: {
      PageTitle,
      Sort
    },
    data: function () {
      return {
        backLink: ``,
        title: 'schedule.cancel_list',
        page: 1,
        filter: {
          name: '',
          type: '',
          reason: '',
          created_at: '',
          romaji: '',
          furigana: '',
          class: '',
          place_name: '',
          day: ''
        },
        sort: {
          name: null,
          type: null,
          reason: null,
          created_at: null,
          romaji: null,
          furigana: null,
          class: null,
          place_name: null,
          day: null
        },
        SCHEDULE_CANCEL_DATE,
        SCHEDULE_CANCEL_DAY,
        SCHEDULE_CANCEL_PERIOD,
        SCHEDULE_BOOKING,
        isBack: false,
        data: null,
        filterTimeout: null,
        date: null,
        classList: []
      }
    },
    methods: {
      goToDetail(cancelItem) {
        let id = cancelItem.id
        let type = cancelItem.type

        this.saveState()
        this.$router.push({path: '/schedule/cancel/detail', query: { id, type }})
      },
      saveState: function () {
        this.$store.commit('notification/updateCancelState', {
          filter: this.filter,
          sort: this.sort,
          page: this.page
        })
      },
      didSelectPage: function (e) {
        this.page = e
        this.retrieveData()
      },
      getCancelType: function (type) {
        switch (type) {
          case SCHEDULE_CANCEL_DATE:
            return this.$t('schedule.cancel_by_date')
          case SCHEDULE_CANCEL_DAY:
            return this.$t('schedule.cancel_by_day')
          case SCHEDULE_CANCEL_PERIOD:
            return this.$t('schedule.cancel_by_period')
          default:
            return this.$t('schedule.booking')
        }
      },
      resetFilter: function () {
        this.filter = Object.assign({}, {
          name: '',
          type: '',
          reason: '',
          created_at: '',
          romaji: '',
          furigana: '',
          class: '',
          place_name: '',
          day: ''
        })

        this.sort = Object.assign({}, {
          name: null,
          type: null,
          reason: null,
          created_at: null,
          romaji: null,
          furigana: null,
          class: null,
          place_name: null,
          day: null
        })
      },
      getData (cancel) {
        switch (cancel.type) {
          case SCHEDULE_CANCEL_DATE:
          case SCHEDULE_BOOKING:
            return cancel.data ? cancel.data.date : ''
          case SCHEDULE_CANCEL_DAY:
            return cancel.data ? this.getDayData(cancel.data) : ''
          case SCHEDULE_CANCEL_PERIOD:
            return cancel.data ? `${cancel.data.start_date} ~ ${cancel.data.end_date}` : ''
          default:
            break
        }
      },
      getDayData (data) {
        let day = DAY_LIST_FULL[data.day] ? this.$t(`calendar.full_day.${DAY_LIST_FULL[data.day]}`) : ''
        let month = MONTH_LIST[data.month] ? this.$t(`calendar.month.${MONTH_LIST[data.month]}`) : ''
        let year = data.year || this.$moment().format('YYYY')

        return day && month ? `${day} - ${month} - ${year}` : ''
      },
      retrieveData: function () {
        let filter = this.filter
        let sort = this.sort
        let page = this.page
        let successCallback = (response) => {
          this.data = Object.assign({}, response.data.data)
        }

        this.$store.dispatch('notification/retrieveCancelList', {
          filter, sort, page, successCallback
        })
      },
      changeSort (type, field) {
        this.sort[field] = type
        this.sort = Object.assign({}, this.sort)
        this.retrieveData()
      },
      exportData: function () {
        let payload = {
          successCallback: (response) => {
            let name = `cancels_${moment(this.date).format('YYYYMMDD')}`
            let type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            downloadFileFromBlob (response.data, type, name, 'xlsx')
          },
          date: this.date,
          lang: this.lang
        }

        this.$store.dispatch('schedule/exportCancels', payload)
      },
      canAddNew: function (notification) {
        if (notification.type !== USER_NOTIFICATION_TYPE_CANCEL) {
          return false
        }

        if (this.page !== 1) {
          return false
        }

        if (this.filter.name && notification.fullname.indexOf(this.filter.name) === -1) {
          return false
        }

        if (this.filter.romaji && notification.romaji.indexOf(this.filter.romaji) === -1) {
          return false
        }

        if (this.filter.furigana && notification.furigana.indexOf(this.filter.furigana) === -1) {
          return false
        }

        if (this.filter.class && notification.class_id !== this.filter.class) {
          return false
        }

        if (this.filter.place_name && notification.place_name.indexOf(this.filter.place_name) === -1) {
          return false
        }

        if (this.filter.type && notification.type !== this.filter.type) {
          return false
        }

        if (this.filter.reason && notification.reason.indexOf(this.filter.reason) === -1) {
          return false
        }

        if (this.filter.created_at && this.filter.created_at !== this.$moment(notification.created_at).format('YYYY-MM-DD')) {
          return false
        }
      },
      createCancel () {
        this.$router.push({path: '/schedule/cancel/add'})
      },
      deleteCancel (cancel) {
        this.$store.commit('openConfirm', {
          title: this.$t('common.delete'),
          message: this.$t('common.cancel_delete_confirm'),
          callback: () => {
            let payload = {
              id: cancel.id,
              successCallback: () => {
                if (this.data.data.length <= 1) {
                  this.page = this.page > 1 ? this.page - 1 : 1
                }

                this.retrieveData()
              }
            }

            this.$store.dispatch('schedule/deleteCancel', payload);
          }
        })
      },
      getDayOptionList (data) {
        let dayList = []

        for (let key in WORKING_DAY_LIST) {
          dayList.push({
            value: key,
            label: this.$t(`calendar.full_day.${WORKING_DAY_LIST[key]}`)
          })
        }

        return dayList
      }
    },
    mounted: function () {
      this.$store.dispatch('classroom/retrieveClassList', {
        successCallback: (response) => {
          this.classList = [].concat(response.data.data.class_list)
        }
      })
      this.retrieveData()
    },
    computed: {
      ...mapState('notification', ['currentCancelFilter', 'currentCancelSort', 'currentCancelPage']),
      ...mapState('login', ['lang']),
      sortedClassList: function () {
        let sortedClassList = [].concat(this.classList)
        sortedClassList.sort((before, after) => classSort(before, after))
        return sortedClassList
      }
    },
    created: function () {
      if (this.$route.query.action && this.$route.query.action === "back") {
        if (this.currentCancelFilter) {
          this.filter = Object.assign({}, this.currentCancelFilter)
          this.isBack = true
        }

        if (this.currentCancelSort) {
          this.sort = Object.assign({}, this.currentCancelSort)
        }

        if (this.currentCancelPage) {
          this.page = this.currentCancelPage
        }
      }

      this.$store.commit('notification/updateCancelState', {
        filter: null,
        sort: null,
        page: null
      })
    },
    watch: {
      filter: {
        deep: true,
        handler: function () {
          if (this.isBack) {
            this.isBack = false
            return
          }

          clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            this.retrieveData()
          }, 1000)

          this.page = 1
        }
      }
    },
    sockets: {
      notifications (notification) {
        if (this.canAddNew(notification.data)) {
          if (this.data.data.length >= this.data.per_page) {
            this.data.data.pop()
          }

          this.data.data.unshift(notification.data)
        }
      },
      notificationRead (notification) {
        if (notification.type === USER_NOTIFICATION_TYPE_CANCEL) {
          this.data.data.forEach((item) => {
            if (item.id === notification.data.id) {
              item.is_read = true
            }
          })
        }
      }
    }
  }
</script>
<style lang="scss">
  .cancel-list {
    .notification-no {
      position: relative;

      .notification-badge {
        width: 10px;
        height: 10px;
        border-radius: 100%;
        position: absolute;
        top: 5px;
        left: 5px;
        background: #ca0000;
        display: none;
      }

      &.is-unread {
        .notification-badge {
          display: block;
        }
      }
    }

    .el-date-editor.el-input {
      width: 100%!important;
    }
  }
</style>
